import '../assets/css/mini.css';

import React, { useState } from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import { yupResolver } from '@hookform/resolvers/yup';
import { Input, Select, notification, Spin } from 'antd';
import { Controller, useForm } from 'react-hook-form';
import * as yup from "yup";
import axios from '../common/axios_call';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';
import WhatsappImage from '../assets/images/icons/whatsapp.png';

const Contact = () => {

    const antIcon = <LoadingOutlined style={{ fontSize: 24, color: '#fff', marginLeft: 20 }} spin />;

    const [loadMessageButton, setLoadMessageButton] = useState(false);

    const openNotificationWithIcon = (type, message) => {
        notification[type]({
            message: '',
            placement: 'bottomRight',
            description: message,
        });
    };

    const joinUsVerification = yup.object().shape({
        firstName: yup.string().required('Please enter your first name').min(2, 'First name can not be less than 2 characters'),
        lastName: yup.string().required('Please enter your last name').min(2, 'Last name can not be less than 2 characters'),
        emailAddress: yup.string().email().required('Please enter your email address').min(5, 'Email address can not be less than 5 characters'),
        phoneNumber: yup.string().required('Please enter your phone number').min(11, 'Phone number can not be less than 11 characters'),
        helpType: yup.string().required('Please select how we can help you'),
    })


    const { handleSubmit, control, setValue, formState: { errors } } = useForm({
        resolver: yupResolver(joinUsVerification)
    });

    const handleContact = e => {
        setLoadMessageButton(true);
        let { firstName, lastName, emailAddress, phoneNumber, message } = e;
        let joinUsMssg = {
            first_name: firstName,
            last_name: lastName,
            email: emailAddress,
            phone_number: phoneNumber,
            help_type: e.helpType,
            interrest: '',
            message
        }
        axios.post('/feed-back/contactus', joinUsMssg).then(res => {
            setLoadMessageButton(false);
            if (res.data.statusMessage === "success") {
                setValue('firstName', '');
                setValue('lastName', '');
                setValue('emailAddress', '');
                setValue('phoneNumber', '');
                setValue('message', '');
                openNotificationWithIcon('success', res.data.message);
            } else {
                openNotificationWithIcon('error', res.data.message);
            }
        }).catch(err => {
            setLoadMessageButton(false);
            openNotificationWithIcon('error', err.response.data.message);
        })
    }
    return (
        <div>
            <Navbar />
            <div className="mini_header top_header">
                <div className="mini_header_content">
                    <div className="new_flex contain contactus">
                        <div className="flex_div">
                            <div className="new_header_div_inside">
                                <div>
                                    <h3>Need help today? <br /> Fill the form or <br /> Chat with us.</h3>
                                    <p><b>Support team</b></p>
                                    <div className="contact_page_list">
                                        <p>Consukon Limited</p>
                                        <br /><p>Address: 157 ipaja road, Baruwa, ipaja, <br /> Lagos</p>
                                        <a target='_blank' href="tel:+2348073376943">Telephone: +2348073376943</a> <br /><br />
                                        <a target='_blank' href="https://wa.me/message/VDOXKM2HBTWXF1"><img style={{ height:"6.5rem" }} src={WhatsappImage} alt="WhatsApp Chat Icon"/></a> <br />
                                    </div>
                                </div>  
                            </div>
                        </div>
                        <div className="flex_div">
                            <div className="bg_white">
                                <form autoComplete="off" onSubmit={handleSubmit(handleContact)}>
                                    <div className="form-flex-2">
                                        <div className="form-group space">
                                            <label htmlFor="firstName">First name</label>
                                            <Controller name="firstName" defaultValue='' control={control}
                                                render={
                                                    ({ field }) => (
                                                        <Input {...field} id="firstName"
                                                            type="text" style={{ height: '5rem' }} />
                                                    )
                                                } />
                                            {errors.firstName && <p className="error-message">{errors.firstName.message}</p>}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="lastName">Last name</label>
                                            <Controller name="lastName" defaultValue={''} control={control}
                                                render={
                                                    ({ field }) => (
                                                        <Input {...field} id="lastName"
                                                            type="text" style={{ height: '5rem' }} />
                                                    )
                                                } />
                                            {errors.lastName && <p className="error-message">{errors.lastName.message}</p>}
                                        </div>
                                    </div>
                                    <div className="form-flex-2">
                                        <div className="form-group">
                                            <label htmlFor="emailAddress">Email address</label>
                                            <Controller name="emailAddress"
                                                defaultValue={''} control={control}
                                                render={
                                                    ({ field }) => (
                                                        <Input type="email" id="emailAddress" {...field} style={{ height: '5rem' }} />
                                                    )} />
                                            {errors.emailAddress && <p className="error-message">{errors.emailAddress.message}</p>}
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="phoneNumber">Phone number</label>
                                            <Controller name="phoneNumber"
                                                defaultValue={''} control={control}
                                                render={
                                                    ({ field }) => (
                                                        <Input type="tel" id="phoneNumber" {...field} style={{ height: '5rem' }} />
                                                    )} />
                                            {errors.phoneNumber && <p className="error-message">{errors.phoneNumber.message}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="helpType">How can we help?</label>
                                        <Controller
                                            name="helpType"
                                            control={control}
                                            defaultValue={undefined}
                                            render={({ field }) => (
                                                <Select
                                                    {...field}
                                                    id="helpType"
                                                    style={{ width: '100%', height: '5rem' }}
                                                    placeholder="Select an option"
                                                >
                                                    <Select.Option value="I want to become a restaurant">
                                                        I want to become a restaurant
                                                    </Select.Option>
                                                    <Select.Option value="I want to cancel my account">
                                                        I want to cancel my account
                                                    </Select.Option>
                                                    <Select.Option value="I want to talk to a support manager">
                                                        I want to talk to a support manager
                                                    </Select.Option>
                                                    <Select.Option value="I want to join the delivery team">
                                                        I want to join the delivery team
                                                    </Select.Option>
                                                </Select>
                                            )}
                                        />
                                        {errors.helpType && <p className="error-message">{errors.helpType.message}</p>}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="message">Message</label>
                                        <Controller name="message" defaultValue="" control={control}
                                            render={
                                                ({ field }) => (
                                                    <Input.TextArea rows={4} {...field} id="message" />
                                                )
                                            } />
                                        {errors.message && <p className="error-message">{errors.message.message}</p>}
                                    </div>
                                    <div style={{ marginTop: '7%' }}></div>
                                    <div className="">
                                        {
                                            !loadMessageButton ?
                                                <button style={{ display: 'block', width: "100%", height: '5rem' }} className="bg_green_long no_border">Send message</button>
                                                :
                                                <button disabled style={{ display: 'block', width: "100%", height: '5rem' }} className="bg_green_long no_border" id="modal-button">Sending message. Please wait.<Spin indicator={antIcon} /></button>
                                        }
                                    </div>
                                    <div style={{ clear: 'both' }}></div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer noSpace={true} />
        </div>
    )
}

export default Contact;